import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Warning } from "@phosphor-icons/react";

export default function DuplicateUploadDialog({ dupPrompt, onCancel, onConfirm }) {
  return (
    <AlertDialog open={!!dupPrompt} onOpenChange={(v) => { if (!v) onCancel(); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading flex items-center gap-2">
            <Warning size={18} weight="fill" className="text-amber-600" />
            Archivo ya importado
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-[13px]">
              <p>Este Excel ya fue subido anteriormente:</p>
              {dupPrompt && (
                <div className="border border-[#E5E5E5] rounded-sm p-3 bg-neutral-50 text-[12px] font-mono space-y-1">
                  <div>Archivo: {dupPrompt.existing.filename}</div>
                  <div>Cargado: {new Date(dupPrompt.existing.created_at).toLocaleString("es-AR")}</div>
                  <div>Ventas creadas: {dupPrompt.existing.count}</div>
                </div>
              )}
              <p className="text-amber-700">¿Subirlo igual? Se generarán ventas duplicadas.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-sm">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="rounded-sm bg-amber-600 hover:bg-amber-700">
            Subir de todas formas
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
